import type { ReactNode } from "react";

import auroraBase from "@/assets/figma/home/aurora-base.png";
import auroraOverlay from "@/assets/figma/home/aurora-overlay.png";
import { cn } from "@/shared/lib/cn";

interface MerryAuroraPageProps {
  children: ReactNode;
  figmaNodeId?: string;
  labelledBy: string;
  testId: string;
}

interface MerryAuroraBackdropProps {
  className?: string;
}

export function MerryAuroraBackdrop({
  className,
}: MerryAuroraBackdropProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden",
        className,
      )}
    >
      <img
        alt=""
        className="absolute inset-0 size-full max-w-none object-cover"
        src={auroraBase}
      />
      <img
        alt=""
        className="absolute inset-0 size-full max-w-none object-cover"
        src={auroraOverlay}
      />
    </div>
  );
}

export function MerryAuroraPage({
  children,
  figmaNodeId,
  labelledBy,
  testId,
}: MerryAuroraPageProps) {
  return (
    <main className="min-h-svh" data-testid={testId}>
      <section
        aria-labelledby={labelledBy}
        className="relative isolate flex min-h-svh w-full flex-col items-start justify-center overflow-hidden"
        data-figma-node-id={figmaNodeId}
      >
        <MerryAuroraBackdrop />

        {children}
      </section>
    </main>
  );
}
